import type { ColumnDef } from "@tanstack/react-table"

export function getColumnHeader<T>(col: ColumnDef<T>): string {
  const header = col.header
  if (typeof header === "string") return header
  if (typeof col.id === "string") return col.id
  if (typeof col.accessorKey === "string") return col.accessorKey
  return ""
}

export function isActionsColumn<T>(col: ColumnDef<T>): boolean {
  const header = getColumnHeader(col).toLowerCase()
  return header === "actions" || col.id === "actions"
}

export function partitionColumns<T>(columns: ColumnDef<T>[]) {
  const actionsColumn = columns.find(isActionsColumn)
  const dataColumns = columns.filter((col) => !isActionsColumn(col))
  return { dataColumns, actionsColumn }
}
